import { Select } from "antd";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getStudentScores } from "../../../api/students.api";
import useAxios from "../../../hooks/useAxios";
import { IGetStudentScores } from "../../../models/students.model";
import { RootState } from "../../../store/rootReducer";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Default from "./score/Default";
import Homework from "./score/Homework";
import Participation from "./score/Participation";
import SelectStudentClass from "./SelectStudentClass";

interface IProps {
  memberCode: string|undefined;
  defaultClassCode?: string;
}

const Score: FC<IProps> = ({
  memberCode,
  defaultClassCode,
}) => {
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // GR0001 = 평가 구분
  const GR0001 = commonCodes.find(item => item.commonCode === 'GR0001')?.detailCode;
  const { t } = useTranslation();

  const [classCode, setClassCode] = useState<string>();
  const [learningTypeCode, setLearningTypeCode] = useState<string>();

  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetStudentScores>();

  useEffect(() => {
    if (defaultClassCode) {
      setClassCode(defaultClassCode);
    }
  }, [defaultClassCode]);

  useEffect(() => {
    if (classCode && memberCode && learningTypeCode) {
      execute2(getStudentScores(classCode, memberCode, learningTypeCode));
    }
  }, [classCode, memberCode, learningTypeCode]);

  const renderTable = () => {
    switch (learningTypeCode) {
      case 'HW':
        return <Homework rawData={res2?.data} />;
      case 'PA':
        return <Participation rawData={res2?.data} />;
      default:
        return <Default rawData={res2?.data} />;
    }
  }

  return (
    <>
      {isLoading2 && <Loader />}
      <ErrorResponse error={error2} />

      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <div style={{ width: '220px' }}>
            <SelectStudentClass
              memberCode={memberCode}
              classCode={classCode}
              setClassCode={setClassCode}
            />
          </div>
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('student.student.column45')}
              value={learningTypeCode}
              onChange={value => setLearningTypeCode(value)}
            >
              {GR0001?.map((item: any) => {
                return (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {item.korName}
                  </Select.Option>
                )
              })}
            </Select>
          </div>
        </div>
      </div>

      <div className="mt-0">
        {renderTable()}
      </div>
    </>
  );
}

export default Score;
